export default [{
  name: 'warningRestaurants',
  path: 'warningRestaurants',
  component: () => import('./WarningRestaurants.vue'),
  meta: {
    title: '预警餐厅'
  }
}]



// WEBPACK FOOTER //
// ./src/router/warning_restaurants/index.js